import { Button, DatePicker, Form, Input, Row, Select, Space, notification } from "antd";
import React, { useEffect, useState } from "react";
import Icon from "assets/icons";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import { ColumnsEdit } from "types/models/column-table-edit";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
const { INPUT, SELECT, DATE, AUTO_COMPLETE } = FIELD_TYPE;
import { analysisService } from "api";
import {
  convertIosStringToDateDayjs,
  convertIosStringToDateObj,
  formatDateToString,
} from "helper/common";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setCallApi } from "redux/reducer/reduxCommon";
import Notification from "components/common/notification/notification";
import dayjs from "dayjs";
import moment from "moment";
const TableSpecimens = () => {
  const [listDM, setListDM] = useState([]);
  const [listDV, setListDV] = useState([]);
  const [options, setOptions] = useState([]);
  const [optionsDv, setOptionsDv] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getListBP();
    getListDV();
  }, []);

  const columnsTablePatient: any[] = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      width: "4%",
      align: "center",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Mã bệnh phẩm",
      dataIndex: "maBenhPham",
      key: "maBenhPham",
      align: "left",
    },
    {
      title: "Loại bệnh phẩm",
      dataIndex: "idLoaiBenhPham",
      key: "idLoaiBenhPham",
      align: "left",
      // type: SELECT,
      // options: listDM,
    },
    {
      title: "Lượng bệnh phẩm",
      dataIndex: "luongBenhPham",
      key: "luongBenhPham",
      align: "right",
      width: "8%",
      // type: INPUT,
    },
    {
      title: "Đơn vị tính",
      dataIndex: "idDvt",
      key: "idDvt",
      width: "8%",
      align: "right",
      // type: SELECT,
      // options: listDV,
    },
    {
      title: "Thời gian lấy mẫu",
      dataIndex: "thoiGianLayMau",
      key: "thoiGianLayMau",
      align: "left",
      // type: DATE,
      width: "12%",
      optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    },
    {
      title: "Ghi chú",
      dataIndex: "ghiChu",
      key: "ghiChu",
      align: "left",
      // type: INPUT,
    },
    {
      title: "Nhân viên lấy mẫu",
      dataIndex: "nhanVienLayMau",
      key: "nhanVienLayMau",
      align: "left",
      // type: INPUT,
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      align: "center",
    },
  ];

  const [formBP] = Form.useForm();
  const [datapatients, setDataPatients] = useState([]);
  // const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  // const [selectedRows, setSelectedRows] = useState([]);
  const idXetNghiem = useAppSelector((state) => state.reduxCommon.idXetNghiem);
  const activeTab = useAppSelector((state) => state.common.activeTab);
  const disPath = useAppDispatch();

  useEffect(() => {
    getListSpecimens();
  }, [idXetNghiem]);

  const getListSpecimens = async () => {
    setLoading(true);
    try {
      const response = await analysisService
        .getListSpecimen(idXetNghiem)
        .then((res) => {
          console.log("res mẫu bệnh phẩm", res);
          const data = res.data.map((item) => ({
            key: item.id,
            dvt: item.dvt,
            idDvt: item.dvt,
            maBenhPham: item.maBenhPham,
            loaiBenhPham: item.loaiBenhPham,
            idLoaiBenhPham: item.loaiBenhPham,
            luongBenhPham: item.luongBenhPham,
            thoiGianLayMau: item.thoiGianLayMau,
            ghiChu: item.ghiChu,
            nhanVienLayMau: item.nhanVienLayMau,
          }));
          if (!data.length || !data) {
            setDataPatients([
              {
                thoiGianLayMau: dayjs(),
                nhanVienLayMau: localStorage.getItem("fullName"),
              },
            ]);
          }
          else {
            setDataPatients(data);
          }
          setLoading(false);
        });
    } catch (error) {
      
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách");
    }
  };

  columnsTablePatient.map((record) => {
    if (record.dataIndex == "idLoaiBenhPham") {
      record.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <Select
          style={{ width: "100%" }}
          options={listDM}
          value={value}
          onChange={(e, option) => {
            setDataPatients((prevDataTable) => {
              return prevDataTable.map((prevItem) =>
                prevItem.key === record.key
                  ? {
                      ...prevItem,
                      loaiBenhPham: option.value,
                      idLoaiBenhPham: option.label
                    }
                  : prevItem
              );
            });
          }}
        ></Select>
      );
    }
    if (record.dataIndex == "luongBenhPham") {
      record.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <Input
          style={{ width: "100%" }}
          // placeholder="Nhập"
          value={value}
          onChange={(e) =>
            setDataPatients((prevDataTable) => {
              return prevDataTable.map((prevItem) =>
                prevItem.key === record.key
                  ? {
                      ...prevItem,
                      luongBenhPham: e.target.value,
                    }
                  : prevItem
              );
            })
          }
        ></Input>
      );
    }
    if (record.dataIndex == "idDvt") {
      record.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <Select
          style={{ width: "100%" }}
          options={listDV}
          value={value}
          onChange={(e, option) => {
            setDataPatients((prevDataTable) => {
              return prevDataTable.map((prevItem) =>
                prevItem.key === record.key
                  ? {
                      ...prevItem,
                      dvt: option.value,
                      idDvt: option.label
                    }
                  : prevItem
              );
            });
          }}
        ></Select>
      );
    }
    if (record.dataIndex == "ghiChu") {
      record.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <Input
          style={{ width: "100%" }}
          // placeholder="Nhập"
          value={value}
          onChange={(e) =>
            setDataPatients((prevDataTable) => {
              return prevDataTable.map((prevItem) =>
                prevItem.key === record.key
                  ? {
                      ...prevItem,
                      ghiChu: e.target.value,
                    }
                  : prevItem
              );
            })
          }
        ></Input>
      );
    }
    if (record.dataIndex == "nhanVienLayMau") {
      record.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <Input
          style={{ width: "100%" }}
          // placeholder="Nhập"
          value={value}
          onChange={(e) =>
            setDataPatients((prevDataTable) => {
              return prevDataTable.map((prevItem) =>
                prevItem.key === record.key
                  ? {
                      ...prevItem,
                      nhanVienLayMau: e.target.value,
                    }
                  : prevItem
              );
            })
          }
        ></Input>
      );
    }
    if (record.dataIndex == "thoiGianLayMau") {
      record.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <DatePicker
          value={value ? dayjs(value) : null}
          format={`${FORMAT_TIME.dateTime}`}
          showTime={true}
          onChange={(e) =>
            setDataPatients((prevDataTable) => {
              // console.log('event', e);
              return prevDataTable.map((prevItem) =>
                prevItem.key === record.key
                  ? {
                      ...prevItem,
                      thoiGianLayMau: e ? dayjs(e) : null,
                    }
                  : prevItem
              );
            })
          }
        ></DatePicker>
      );
    }
  })

  const handleOnSaveSpecimens = async (values) => {
    const data = datapatients.map((e) => ({
      ...e,
      thoiGianLayMau: formatDateToString(e.thoiGianLayMau, null),
      idPhieuXetNghiem: idXetNghiem,
      // loaiBenhPham: e.loaiBenhPham ? e.loaiBenhPham : e.idLoaiBenhPham,
      // dvt: e.idDvt ? e.idDvt : e.dvt
    }));

    setLoading(true);
    // console.log("newArray", newArray);
    // const arr = newArray.filter(item => !item.hasOwnProperty("maBenhPham"));
    try {
      const response = await analysisService
        .saveSpecimens(data)
        .then((res) => {
          Notification("success", "Lưu thành công");
          setLoading(false);
        });
    } catch (error) {
      
      Notification("error", "Đã có lỗi xảy ra khi lưu");
      setLoading(false);
    }
    // disPath(setCallApi());
    getListSpecimens();
    disPath(setCallApi());
  };

  const getListBP = async () => {
    try {
      const response = await analysisService
        .getListCategorySpecimen()
        .then((res) => {
          const data = res.data;
          
          const optionsData = data.map((item) => ({
            id: item.id,
            value: item.id,
            label: item.tenLoaiBP,
          }));
          setListDM(optionsData);
        });
    } catch (error) {
      
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách loại bệnh phẩm"
      );
    }
  };

  const getListDV = async () => {
    try {
      const response = await analysisService
        .getListCategoryDVT()
        .then((res) => {
          const data = res.data;
          const optionDv = data.map((item) => ({
            id: item.id,
            value: item.id,
            label: item.tenDVTBP,
          }));
          setListDV(optionDv);
        });
    } catch (error) {
      
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách đơn vị");
    }
  };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: async (selectedRowKeys, selectedRows) => {
  //     setSelectedRowKeys(selectedRowKeys);
  //     console.log(
  //       `selectedRowKeys: ${selectedRowKeys}`,
  //       "selectedRows: ",
  //       selectedRows
  //     );
  //     setSelectedRows(selectedRows);
  //     // const selectedRowStatuses = selectedRows.filter((row) => row.status == 0);
  //     // setDataPost(selectedRowStatuses);
  //   },
  //   getCheckboxProps: (record: any) => ({
  //     name: record.name,
  //   }),
  // };

  return (
    <div className="container">
      <div className="header">Danh sách bệnh phẩm</div>
      <Form form={formBP} onFinish={handleOnSaveSpecimens}>
        <Row justify={"end"} gutter={[16, 8]} style={{ marginBottom: "16px" }}>
          <Space>
            <Button
              type="primary"
              icon={<Icon.save rev={0} />}
              htmlType="submit"
            >
              Lưu
            </Button>
            {/* <Button
              type="ghost"
              className="btn-sub"
              icon={<Icon.printer rev={0} />}
            >
              In mã bệnh phẩm
            </Button> */}
          </Space>
        </Row>

        <Form.Item name={"formBenhPham"}>
          <TableInputAdd
            data={datapatients}
            setData={setDataPatients}
            loading={loading}
            column={columnsTablePatient}
            // rowSelection={{
            //   ...rowSelection,
            // }}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default TableSpecimens;
